/**
 * #userv2.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
import { UserFlairV2 } from "./flair.js";
/**
 * Matches the AccountType enum values listed in account-api's account.proto.
 * https://github.snooguts.net/reddit/account-api/blob/4b375c6876872eaf5b9619beac03069b881f9f82/api/proto/reddit/coreuser/account/v1/account.proto#L40-L69
 */
export var AccountTypeV2;
(function (AccountTypeV2) {
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_UNSPECIFIED"] = 0] = "ACCOUNT_TYPE_UNSPECIFIED";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_USER"] = 1] = "ACCOUNT_TYPE_USER";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_PROXY"] = 2] = "ACCOUNT_TYPE_PROXY";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_APP"] = 3] = "ACCOUNT_TYPE_APP";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_BRAND"] = 4] = "ACCOUNT_TYPE_BRAND";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_ADS_INTEGRATION"] = 5] = "ACCOUNT_TYPE_ADS_INTEGRATION";
    AccountTypeV2[AccountTypeV2["ACCOUNT_TYPE_LITE"] = 6] = "ACCOUNT_TYPE_LITE";
    AccountTypeV2[AccountTypeV2["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AccountTypeV2 || (AccountTypeV2 = {}));
export function accountTypeV2FromJSON(object) {
    switch (object) {
        case 0:
        case "ACCOUNT_TYPE_UNSPECIFIED":
            return AccountTypeV2.ACCOUNT_TYPE_UNSPECIFIED;
        case 1:
        case "ACCOUNT_TYPE_USER":
            return AccountTypeV2.ACCOUNT_TYPE_USER;
        case 2:
        case "ACCOUNT_TYPE_PROXY":
            return AccountTypeV2.ACCOUNT_TYPE_PROXY;
        case 3:
        case "ACCOUNT_TYPE_APP":
            return AccountTypeV2.ACCOUNT_TYPE_APP;
        case 4:
        case "ACCOUNT_TYPE_BRAND":
            return AccountTypeV2.ACCOUNT_TYPE_BRAND;
        case 5:
        case "ACCOUNT_TYPE_ADS_INTEGRATION":
            return AccountTypeV2.ACCOUNT_TYPE_ADS_INTEGRATION;
        case 6:
        case "ACCOUNT_TYPE_LITE":
            return AccountTypeV2.ACCOUNT_TYPE_LITE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AccountTypeV2.UNRECOGNIZED;
    }
}
export function accountTypeV2ToJSON(object) {
    switch (object) {
        case AccountTypeV2.ACCOUNT_TYPE_UNSPECIFIED:
            return 0;
        case AccountTypeV2.ACCOUNT_TYPE_USER:
            return 1;
        case AccountTypeV2.ACCOUNT_TYPE_PROXY:
            return 2;
        case AccountTypeV2.ACCOUNT_TYPE_APP:
            return 3;
        case AccountTypeV2.ACCOUNT_TYPE_BRAND:
            return 4;
        case AccountTypeV2.ACCOUNT_TYPE_ADS_INTEGRATION:
            return 5;
        case AccountTypeV2.ACCOUNT_TYPE_LITE:
            return 6;
        case AccountTypeV2.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseUserV2() {
    return {
        id: "",
        name: "",
        isGold: false,
        snoovatarImage: "",
        url: "",
        spam: false,
        banned: false,
        flair: undefined,
        karma: 0,
        iconImage: "",
        description: "",
        suspended: false,
        accountType: 0,
    };
}
export const UserV2 = {
    $type: "devvit.reddit.v2alpha.UserV2",
    encode(message, writer = _m0.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.isGold !== false) {
            writer.uint32(24).bool(message.isGold);
        }
        if (message.snoovatarImage !== "") {
            writer.uint32(34).string(message.snoovatarImage);
        }
        if (message.url !== "") {
            writer.uint32(42).string(message.url);
        }
        if (message.spam !== false) {
            writer.uint32(48).bool(message.spam);
        }
        if (message.banned !== false) {
            writer.uint32(56).bool(message.banned);
        }
        if (message.flair !== undefined) {
            UserFlairV2.encode(message.flair, writer.uint32(66).fork()).ldelim();
        }
        if (message.karma !== 0) {
            writer.uint32(72).int64(message.karma);
        }
        if (message.iconImage !== "") {
            writer.uint32(82).string(message.iconImage);
        }
        if (message.description !== "") {
            writer.uint32(90).string(message.description);
        }
        if (message.suspended !== false) {
            writer.uint32(96).bool(message.suspended);
        }
        if (message.accountType !== 0) {
            writer.uint32(104).int32(message.accountType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserV2();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) {
                        break;
                    }
                    message.isGold = reader.bool();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.snoovatarImage = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
                case 6:
                    if (tag !== 48) {
                        break;
                    }
                    message.spam = reader.bool();
                    continue;
                case 7:
                    if (tag !== 56) {
                        break;
                    }
                    message.banned = reader.bool();
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.flair = UserFlairV2.decode(reader, reader.uint32());
                    continue;
                case 9:
                    if (tag !== 72) {
                        break;
                    }
                    message.karma = longToNumber(reader.int64());
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.iconImage = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 12:
                    if (tag !== 96) {
                        break;
                    }
                    message.suspended = reader.bool();
                    continue;
                case 13:
                    if (tag !== 104) {
                        break;
                    }
                    message.accountType = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            isGold: isSet(object.isGold) ? globalThis.Boolean(object.isGold) : false,
            snoovatarImage: isSet(object.snoovatarImage) ? globalThis.String(object.snoovatarImage) : "",
            url: isSet(object.url) ? globalThis.String(object.url) : "",
            spam: isSet(object.spam) ? globalThis.Boolean(object.spam) : false,
            banned: isSet(object.banned) ? globalThis.Boolean(object.banned) : false,
            flair: isSet(object.flair) ? UserFlairV2.fromJSON(object.flair) : undefined,
            karma: isSet(object.karma) ? globalThis.Number(object.karma) : 0,
            iconImage: isSet(object.iconImage) ? globalThis.String(object.iconImage) : "",
            description: isSet(object.description) ? globalThis.String(object.description) : "",
            suspended: isSet(object.suspended) ? globalThis.Boolean(object.suspended) : false,
            accountType: isSet(object.accountType) ? accountTypeV2FromJSON(object.accountType) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.isGold !== false) {
            obj.isGold = message.isGold;
        }
        if (message.snoovatarImage !== "") {
            obj.snoovatarImage = message.snoovatarImage;
        }
        if (message.url !== "") {
            obj.url = message.url;
        }
        if (message.spam !== false) {
            obj.spam = message.spam;
        }
        if (message.banned !== false) {
            obj.banned = message.banned;
        }
        if (message.flair !== undefined) {
            obj.flair = UserFlairV2.toJSON(message.flair);
        }
        if (message.karma !== 0) {
            obj.karma = Math.round(message.karma);
        }
        if (message.iconImage !== "") {
            obj.iconImage = message.iconImage;
        }
        if (message.description !== "") {
            obj.description = message.description;
        }
        if (message.suspended !== false) {
            obj.suspended = message.suspended;
        }
        if (message.accountType !== 0) {
            obj.accountType = accountTypeV2ToJSON(message.accountType);
        }
        return obj;
    },
    create(base) {
        return UserV2.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserV2();
        message.id = object.id ?? "";
        message.name = object.name ?? "";
        message.isGold = object.isGold ?? false;
        message.snoovatarImage = object.snoovatarImage ?? "";
        message.url = object.url ?? "";
        message.spam = object.spam ?? false;
        message.banned = object.banned ?? false;
        message.flair = (object.flair !== undefined && object.flair !== null)
            ? UserFlairV2.fromPartial(object.flair)
            : undefined;
        message.karma = object.karma ?? 0;
        message.iconImage = object.iconImage ?? "";
        message.description = object.description ?? "";
        message.suspended = object.suspended ?? false;
        message.accountType = object.accountType ?? 0;
        return message;
    },
};
messageTypeRegistry.set(UserV2.$type, UserV2);
function longToNumber(long) {
    if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
function isSet(value) {
    return value !== null && value !== undefined;
}
